import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {DashboardBox2} from '../components';

class Dashboard2 extends Component {
	render() {
		const {pageTitle} = this.props;

		return (
			<Fragment>
				<Helmet title={pageTitle}/>
				<DashboardBox2/>
			</Fragment>
		);
	}
}

Dashboard2.defaultProps = {
	pageTitle: 'Dashboard'
};

Dashboard2.propTypes = {
	pageTitle: PropTypes.string
};

export default Dashboard2;